var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view_only)?_c('value-container',{attrs:{"value":_vm.value,"label":_vm.label,"md":_vm.md}}):_c(_vm.tag,{tag:"component",attrs:{"md2":_vm.md==2,"md3":_vm.md==3,"md4":_vm.md==4,"md6":_vm.md==6,"md8":_vm.md==8,"md12":_vm.md==12}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }